import React from "react";

export const Spinner = () => {
    return (
        <div className="spinner-border spinner spinner-position" role="status">
            <span className="sr-only"></span>
        </div>
    );
};